import { GridFooterCellProps } from '@progress/kendo-react-grid';
import useViewBudgetPeriod from 'src/hooks/useViewBudgetPeriod';
import { getBgColor } from 'src/utils/icons';
import { round } from 'src/utils/number';

const PercentageFooterCell = (props: GridFooterCellProps) => {
  const { totalPercentage, errorMessage, footerInfoMessage } = useViewBudgetPeriod();

  return (
    <td className={getBgColor(errorMessage.totalPercentage, [], footerInfoMessage)}>
      <p className="text-left">{round(totalPercentage)}%</p>
    </td>
  );
};

export default PercentageFooterCell;
